import React from 'react';

export const WorkflowButtonParentContext = React.createContext(null);
